import 'css-chunksrc/client/pages/projectPage/kanbanPage/loader/column/task/hierarchy/styles.scss';export default {
  "hierarchy": "_hierarchy_7v5up_1",
  "text": "_text_7v5up_17"
};